module.exports = __webpack_public_path__ + "img/若依参考图.57f85fbd.jpg";